export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('Stars', (totalStars = 5, stars = 0, id) => {
        const elementStars = Number(stars) || 0;
        const roundNumber = (percent) => {
          const newPercent =
            percent.length > 1 ? Number(percent) : Number(percent) * 10;
          return Math.round(newPercent / 10) * 10;
        };
        return {
          starsId: id,
          totalStars,
          getClassStar(star) {
            const splitValue = elementStars.toString().split('.');
            const lastStar = splitValue[0];

            if (lastStar === this.totalStars) {
              return 'w-full';
            }

            const tailwindClasses = {
              10: 'w-[10%]',
              20: 'w-[20%]',
              30: 'w-[30%]',
              40: 'w-[40%]',
              50: 'w-[50%]',
              60: 'w-[60%]',
              70: 'w-[70%]',
              80: 'w-[80%]',
              90: 'w-[90%]',
            };

            return star <= parseFloat(stars)
              ? 'w-full'
              : star - parseFloat(stars) < 1 && star - parseFloat(stars) > 0
                ? tailwindClasses[roundNumber(splitValue[1])]
                : 'w-0';
          },
        };
      });
    });
  },
};
